import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('RegistrationRequest', RegistrationRequestData);

    RegistrationRequestData.$inject = ['$filter' ,'$translate'];

    /* @ngInject */
    function RegistrationRequestData($filter ,$translate) {
        RegistrationRequest.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getNameForList:getNameForList,
            getCountryLabel:getCountryLabel,
            getLangLabel:getLangLabel,
            getFiscalKindLabel:getFiscalKindLabel,
            getNationalKindLabel:getNationalKindLabel,
            isAccepted:isAccepted,
            isRejected:isRejected
        };

        function RegistrationRequest(registrationRequestData) {
            if (!registrationRequestData) {
                this.buildEmpty();
            } else {
                this.build(registrationRequestData);
            }
        }

        return RegistrationRequest;

        function buildEmpty() {
            this.id=null;
            this.legalEntityId=null;
            this.creationDate=null;
            this.userFisrtName=null;
            this.userEmail=null;
            this.companyName=null;
            this.status=null;
            this.userLastName=null;
            this.idFiscal=null;
            this.idNational=null;
            this.idFiscalKind=null;
            this.idNationalKind=null;
            this.companyAlias=null;
            this.address1=null;
            this.address2=null;
            this.zipCode=null;
            this.city=null;
            this.state=null;
            this.countryCode=null;
            this.idElectronic=null;
            this.phone=null;
            this.job=null;
            this.language=null;
        }

        function build(registrationRequestData) {
            this.id=registrationRequestData.id || null;
            this.legalEntityId=registrationRequestData.legalEntityId || null;
            this.idFiscal=registrationRequestData.idFiscal ||null;
            this.idNational=registrationRequestData.idNational ||null;
            this.userFisrtName = registrationRequestData.firstname || null;
            this.userLastName = registrationRequestData.lastname || null;
            this.userEmail = registrationRequestData.email || null;
            this.companyName = registrationRequestData.companyName || null;
            this.creationDate = registrationRequestData.creationDate ? $filter('date')(registrationRequestData.creationDate, 'shortDate') :  null;
            this.status = $translate.instant('registration_request.status.' + angular.lowercase(registrationRequestData.status));
            this.companyAlias= registrationRequestData.companyAlias || null;
            buildAddress(this, registrationRequestData);
            buildIds(this, registrationRequestData);
            this.countryCode= registrationRequestData.countryCode || null;
            this.phone= registrationRequestData.phone || null;
            this.job= registrationRequestData.job || null;
            this.language= registrationRequestData.language || null;
        }

        function buildIds(currentObj, registrationRequestData) {
            currentObj.idFiscal = registrationRequestData.idFiscal || null;
            currentObj.idFiscalKind = angular.lowercase(registrationRequestData.idFiscalKind);
            currentObj.idNational = registrationRequestData.idNational || null;
            currentObj.idNationalKind = angular.lowercase(registrationRequestData.idNationalKind);
            currentObj.idElectronic = registrationRequestData.idElectronic || null;
        }

        function buildAddress(currentObj, registrationRequestData) {
            currentObj.address1 = registrationRequestData.address1 || null;
            currentObj.address2 = registrationRequestData.address2 || null;
            currentObj.zipCode = registrationRequestData.zipCode || null;
            currentObj.city = registrationRequestData.city || null;
            currentObj.state = registrationRequestData.state || null;
        }

        /**
         * Retourne le nom du entreprise préinscrite pour l'affichage dans la liste : companyName (Identifiant)
         */
         function getNameForList() {
            var name = this.companyName;
            if (this.idFiscal) {
                name += ' (' + this.idFiscal + ')';
            } else if (this.idNational) {
                name += ' (' + this.idNational + ')';
            }
            return name;
        }

        /**
         * Récupère le label de la langue
         */
        function getLangLabel() {
            return $translate.instant('lang.' + angular.lowercase(this.language));
        }
    
        /**
         * Récupère le label du Pays
         */
        function getCountryLabel() {
            if (this.countryCode) {
                return $translate.instant('country.' + angular.lowercase(this.countryCode));
            }
            return '';
        }

        /**
         * Récupère le label du type d'identifiant fiscal
         */
         function getFiscalKindLabel() {
            if (this.idFiscalKind) {
                return $translate.instant('identifiant.type.' + angular.lowercase(this.idFiscalKind));
            }
            return '';
        }

        /**
         * Récupère le label du type d'identifiant national
         */
        function getNationalKindLabel() {
            if (this.idNationalKind) {
                return $translate.instant('identifiant.type.' + angular.lowercase(this.idNationalKind));
            }
            return '';
        }

        function isAccepted() {
            return this.status && this.status === "Validée";
        }

        function isRejected() {
            return this.status && this.status === "Rejetée";
        }

    }
})();
